// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 6001) return "static/chunks/6001-c3ef2ad255139ac0.js";
	if (chunkId === 3309) return "static/chunks/3309-17ea5ab63567a507.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 8513 ? "58474bfb" : chunkId) + "." + {"2146":"54f2f7a75b9b6cad","3758":"6cbbe757d8998503","5609":"5f9ad016d4238391","7033":"5f65ebae8217914b","7557":"152ce2c323b44181","8513":"528a3aabb9ba4b19","9167":"cca5818fc6910926"}[chunkId] + ".js";
};